import { defineComponent as S, useTemplateRef as C, computed as y, createBlock as a, openBlock as l, unref as n, normalizeStyle as B, normalizeClass as D, withCtx as u, renderSlot as F, createElementBlock as f, createCommentVNode as g, createElementVNode as k, toDisplayString as v, Fragment as m, renderList as I, mergeProps as h, toHandlers as b, createVNode as H } from "vue";
import { RevList as w } from "@ds/components/List";
import { RevListItemStatic as L } from "@ds/components/ListItemStatic";
import { tw as i } from "../../../utils/tailwind.js";
import { isOptionsGroup as E } from "../InputSelectSearchable.helpers.js";
import p from "./InputSelectSearchableItem.vue2.js";
const N = { class: "text-static-default-low px-20" }, P = { class: "text-action-default-hi body-1-bold px-24" }, G = /* @__PURE__ */ S({
  __name: "InputSelectSearchableOptionsList",
  props: {
    view: {},
    noOptionsMessage: {},
    maxHeight: { default: "" },
    hide: { type: Function },
    hideCheckbox: { type: Boolean },
    isOptionSelected: { type: Function },
    options: {},
    listId: {},
    defaultOption: {},
    searchPlacement: {},
    getListItemListeners: { type: Function },
    flatOptionIndexes: {},
    activeOptionIndex: {}
  },
  setup(s) {
    const d = C("listbox");
    function c(e) {
      var t;
      const o = s.flatOptionIndexes[e.id] === s.activeOptionIndex;
      return {
        id: e.id,
        hideCheckbox: s.hideCheckbox,
        isSelected: s.isOptionSelected(e),
        label: e.label,
        description: e == null ? void 0 : e.description,
        suffix: e == null ? void 0 : e.suffix,
        listboxElement: (t = d.value) == null ? void 0 : t.$el,
        class: o ? i`bg-static-default-min-hover` : i`!bg-static-default-min`
      };
    }
    const O = y(() => s.searchPlacement === "dropdown"), x = y(() => {
      const e = i`rounded-sm overflow-y-auto`, o = i`bg-action-default-low shadow-long mt-4`, t = i`p-0`, r = i`[&>li:first-of-type]:!border-static-default-mid`;
      return [
        e,
        s.view === "desktop" ? o : t,
        s.view === "desktop" && O.value ? r : null
      ];
    });
    return (e, o) => (l(), a(n(w), {
      id: e.listId,
      ref_key: "listbox",
      ref: d,
      class: D(x.value),
      "has-external-borders": !1,
      role: "listbox",
      style: B({ maxHeight: e.maxHeight })
    }, {
      default: u(() => [
        F(e.$slots, "search"),
        e.options.length === 0 ? (l(), a(n(L), {
          key: 0,
          role: "presentation"
        }, {
          label: u(() => [
            k("span", N, v(e.noOptionsMessage), 1)
          ]),
          _: 1
        })) : d.value ? (l(!0), f(m, { key: 1 }, I(e.options, (t) => (l(), f(m, {
          key: t.id
        }, [
          n(E)(t) ? (l(), a(n(w), {
            key: 1,
            "aria-labelledby": t.id,
            "has-external-borders": !1,
            role: "group"
          }, {
            default: u(() => [
              H(n(L), {
                id: t.id,
                "aria-label": t.label,
                role: "presentation"
              }, {
                label: u(() => [
                  k("span", P, v(t.label), 1)
                ]),
                _: 2
              }, 1032, ["id", "aria-label"]),
              (l(!0), f(m, null, I(t.options, (r) => (l(), a(p, h({
                key: r.id
              }, { ref_for: !0 }, c(r), b(e.getListItemListeners(r, e.hide))), null, 16))), 128))
            ]),
            _: 2
          }, 1032, ["aria-labelledby"])) : (l(), a(p, h({
            key: 0,
            class: "border-static-default-low"
          }, { ref_for: !0 }, c(t), b(e.getListItemListeners(t, e.hide))), null, 16))
        ], 64))), 128)) : g("", !0),
        e.defaultOption && d.value ? (l(), a(p, h({ key: 2 }, c(e.defaultOption), b(e.getListItemListeners(e.defaultOption, e.hide))), null, 16)) : g("", !0)
      ]),
      _: 3
    }, 8, ["id", "class", "style"]));
  }
});
export {
  G as default
};
